import { ReactNode, createContext } from 'react';
import useProvideAuth from '@/hooks/useProvideAuth';
import type { AuthUser } from '@/types/auth';

export interface AuthContextType {
  user: any;
  logIn: (username: string, password: string, sessionCloseMode?: 'closeOldest' | 'closeAll') => Promise<any>;
  logOut: () => Promise<any>;
  setUser: React.Dispatch<React.SetStateAction<any>>;
  signUp: (data: any) => Promise<any>;
  sendPasswordResetEmail: (email: string) => void;
  confirmPasswordReset: (code: string, password: string) => void;
  currentUser: AuthUser | null;
  setCurrentUser: React.Dispatch<React.SetStateAction<AuthUser | null>>;
  isLoadingCurrent: boolean;
}

const AuthContext = createContext<AuthContextType>(null!);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const value = useProvideAuth();

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
